/**
 * Created by tayloremolo on 11/4/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";
import CTA from "../components/cta";

class GerardSection extends Component {
    // constructor() {
    //     super();
    //
    // }
    // componentDidMount(){
    //     });
    // }

    render() {

        return (
            <div>
                <div className="section-3-et block-4 z-15">
                    <div className="container relative-text p-20">
                        <div className="row m0 valign-wrapper hide-on-med-and-down">
                            <div className="col s12 m7 center-align">
                                <p className="f-38 brand-text text-normal right-align mobile-center text-uppercase mb0">Founder & Leader</p>
                                <h1 className="f-62 black-text bold-text text-uppercase right-align mobile-center mb0 text-shadow-blue">Gerard<br/><span className="f-100 ls-5 black-text">Adams</span> </h1>
                                <p className="f-18 black-text right-align mobile-center">“Your life is a direct result of your dominant thoughts and your daily actions. Stop allowing outside situations mess with you internally and hold you back from moving forward.”</p>
                                <p className="f-18 black-text right-align mobile-center">At this mastermind, I will have only one focus, <br className="hide-on-med-and-down"/> to help get you get <span className="f-26 bold-text text-uppercase ls-3">RESULTS.</span></p>
                                <div className="col s12 right-align mobile-center p0">
                                    <CTA/>
                                    <br/>
                                </div>
                            </div>
                            <div className="col s12 m5">
                                <img className="img-sticky responsive-img relative-text" src="../static/Mastermind-Gerard-Adams.png" alt="Gerard Adams"/>
                            </div>
                        </div>
                        {/*MOBILE VERSION*/}
                        <div className="row m0 hide-on-large-only">
                            <div className="col s12 center-align">
                                <p className="f-26 brand-text mobile-center text-uppercase mb0">Founder & Leader</p>
                                <h1 className="f-62 black-text bold-text text-uppercase mobile-center mb0 text-shadow-blue">Gerard<br/><span className="f-100 ls-5 black-text">Adams</span> </h1>
                                <p className="f-18 black-text mobile-center">“Your life is a direct result of your dominant thoughts and your daily actions. Stop allowing outside situations mess with you internally and hold you back from moving forward.”</p>
                                <p className="f-18 black-text mobile-center">At this mastermind, I will have only one focus, to help get you get <span className="f-26 bold-text text-uppercase ls-3">RESULTS.</span></p>
                                <div className="col s12 center-align p0">
                                    <CTA/>
                                    <br/>
                                </div>
                            </div>
                            <div className="col s12 m10 offset-m1">
                                <img className="img-sticky responsive-img relative-text" src="../static/Mastermind-Gerard-Adams.png"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}

export default GerardSection;


// WEBPACK FOOTER //
// ./src/components/gerard-section.js